import { FundamentalValuationsType } from '../schemas/FUNDAMENTAL_VALUATIONS';
import { formatCurrency } from './formatCurrency';

const decimalFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
const numberFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

const asFiniteNumber = (value: unknown) => {
    const numericValue = Number(value);

    return Number.isFinite(numericValue) ? numericValue : undefined;
};

const accountingWrap = (value: number, formattedAbsoluteValue: string) =>
    value < 0 ? `(${formattedAbsoluteValue})` : formattedAbsoluteValue;

export const formatFinancialMetric = (value: unknown, type?: FundamentalValuationsType) => {
    const numericValue = asFiniteNumber(value);

    if (numericValue === undefined) {
        return '—';
    }

    switch (type) {
        case FundamentalValuationsType.PERCENT:
            return accountingWrap(numericValue, `${decimalFormatter.format(Math.abs(numericValue) * 100)}%`);

        case FundamentalValuationsType.RATIO:
            return accountingWrap(numericValue, `${decimalFormatter.format(Math.abs(numericValue))}x`);

        case FundamentalValuationsType.NUMBER:
            return accountingWrap(numericValue, numberFormatter.format(Math.abs(numericValue)));

        case FundamentalValuationsType.VALUE:
        default:
            return formatCurrency.format(numericValue);
    }
};
